import { create } from "zustand";
import { signOut } from "@/services/auth/clerk";
import { UserObj } from "@/types/interfaces/common";

interface AuthStore {
  user: UserObj | null;

  logoutUser: () => void;
  setCurrentUser: (user: UserObj) => void;
}

const useAuthStore = create<AuthStore>((set) => ({
  user: null,

  logoutUser: () => {
    set({
      user: null,
    });

    // signs out of Clerk and reloads the website
    signOut();
  },
  setCurrentUser: (user) =>
    set({
      user: {
        ...user,
        isAdmin: user.role === "STAFF" ? true : false,
        // isAdmin: true,
      },
    }),
}));

export default useAuthStore;
